import * as React from "react";
import styled from "styled-components";

import { Container } from "@ui/Atoms/Grid";
import theme from "@ui/themes/default";
import { Heading, Segment } from "@ui/Atoms";
import { Testimonials as TestimonialsMolecule } from "@ui/Molecules/Testimonials";

interface TestimonialListItem {
  testimonial_quote: { text: string };
  testimonial_author: { text: string };
  testimonial_rating: number;
}

export interface TestimonialsData {
  testimonialsTitle?: string;
  testimonials?: Testimonial[];

  testimonials_title?: { text: string };
  testimonials_list?: TestimonialListItem[];
}

interface Testimonial {
  quote: string;
  author: string;
  rating: number;
}

interface Props {
  data: TestimonialsData;
}

const Testimonials = ({ data }: Props): React.ReactElement => {
  const getTestimonials = () => {
    return data.testimonials_list?.map(testimonialItem => ({
      quote: testimonialItem.testimonial_quote.text,
      author: testimonialItem.testimonial_author.text,
      rating: testimonialItem.testimonial_rating,
    }));
  };

  const testimonials = getTestimonials();

  return (
    <Background>
      <Container>
        <Segment>
          <Title type="h2" styleAs="h4">
            {data.testimonialsTitle || data.testimonials_title?.text || ""}
          </Title>
          {testimonials && <TestimonialsMolecule testimonials={testimonials} />}
        </Segment>
      </Container>
    </Background>
  );
};

export { Testimonials };

const Background = styled.div`
  background: ${theme.palette.grey50};
  overflow: hidden;
`;

const Title = styled(Heading)`
  margin-bottom: ${theme.margins.base_x6};
  font-weight: ${theme.fonts.weights.bold};
`;
